import {useEffect, useState} from "react";
import ITalent from "../core/interfaces/ITalent";
import getProfilePicture from "../core/utils/getProfilePicture";
import updateCompanyPackageTalentStatusRequest from "../core/api/requests/companies/package/updateCompanyPackageTalentStatusRequest";
import {useDispatch, useSelector} from "react-redux";
import convertToFraction from "../core/utils/convertToFraction";
import {RootState} from "../core/store/store.ts";
import tlt from "../core/api/helpers/translator/translator.ts";
import {useIntl} from "react-intl";
import IReducedEvent from "../core/interfaces/IReducedEvent";
import { useNavigate } from "react-router-dom";
import navigateTo from "../core/utils/navigateTo.ts";
import ERoutes from "../core/enums/ERoutes.ts";
import moment from "moment/moment";

export interface IComponent {
  talent: ITalent;
  companyId?:string
  packageId?:string
  showDetails?: boolean
  allowSelect?: boolean
  onSelect?: (talent:ITalent) => void
  publicView?: boolean
  out?: IReducedEvent[]
}

export default function TalentBigButton(props: IComponent) {
  const dispatch = useDispatch()
  const intl = useIntl()
  const navigate = useNavigate()
  const futils = useSelector((state: RootState) => state.frontendUtilities)
  const [ imageUri, setImageUri ] = useState<string>('')
  const [ statusSelection, setStatusSelection] = useState<string>('')

  const pkg = useSelector((state: RootState) => state.package)

  const getEventColor = (type: string): string => {
    const t = futils?.futils?.events?.types?.find((t: any) => t.name === type)
    return t?.color || '#C7C5C5'
  }

  useEffect(() => {
    const u = getProfilePicture(props.talent)
    setImageUri(u)

    const guestInformation = pkg?.package?.recipient || pkg?.package?.recipients?.find((t: any) => t.recipient?.email === pkg.guestEmail)
    if (!guestInformation) return

    const tltSelection = guestInformation?.talentStatus?.find((t: any) => t.talentId === props.talent.id)
    if (!tltSelection) return

    setStatusSelection(tltSelection.status)
  }, [props.talent]);

  const redirectToTalent = () => {
    if (props.talent.id) {
      if(!props.showDetails){
        window.open(`/talents/${props.talent.id}`, '_blank')
      } else if(props.onSelect) {
        props?.onSelect(props.talent)
      }
    }
  }

  const changeStatus = async (status: string) => {
    if (status === 'pending') return

    setStatusSelection(status)

    if(props.companyId && props.packageId && props.talent.id){
      await updateCompanyPackageTalentStatusRequest(
        dispatch,
        props.companyId,
        props.packageId,
        props.talent.id,
        status,
        pkg?.guestEmail || '',
      );
    }
  }

  useEffect(() => {
    const guestInformation = pkg?.package?.recipient || pkg?.package?.recipients?.find((t: any) => t.recipient?.email === pkg.guestEmail)
    if (!guestInformation) return

    const tltSelection = guestInformation?.talentStatus?.find((t: any) => t.talentId === props.talent.id)
    if (!tltSelection) return

    setStatusSelection(tltSelection.status)
  }, []);

  const {measurements} = props.talent?.talent?.physical || {}

  return <div className={'talent-super-container col-6 col-md-4 col-lg-3 col-xl-2'}>
    <div className={`talent-container mb-1`}>
      <div className={'talent-background'} style={{backgroundImage: `url(${imageUri})`}} onClick={redirectToTalent}>
        {props.out && props.out.length > 0 &&
          <div className="position-absolute talent-out-indicator" style={{top: '8px', right: '8px', zIndex: 1}}>
            <i className="fa-solid fa-triangle-exclamation text-warning fs-3"></i>
            <div className="talent-out-popover position-absolute top-100 end-0 mt-1">
              <div className="bg-body rounded shadow-sm border p-3" style={{minWidth: '250px'}}>
                <div className="fw-bold text-muted fs-8 mb-2">{intl.formatMessage({ id: 'LABELS.TALENT_OUT' })}</div>
                {props.out.map((event) => (
                  <a
                    key={event.id}
                    href="#"
                    className="d-flex align-items-center py-1 text-hover-primary"
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigateTo(e, navigate, ERoutes.BOOKING_INFORMATION.replace(':id', event.id)) }}
                  >
                    <span className="bullet bullet-dot me-2" style={{backgroundColor: getEventColor(event.type)}}></span>
                    <div className="d-flex flex-column">
                      <span className="fs-7 fw-semibold text-gray-800">{event.name}</span>
                      <span className="fs-8 text-muted">{moment(event.startDate).format('DD/MM')} - {moment(event.endDate).format('DD/MM')}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        }
        {props.showDetails &&
          <div className={'talent-info position-absolute'}>
              <span className="talent-name text-capitalize fw-bold">{props.talent.fullName || `${props.publicView ? props.talent.name?.split(' ')[0] : props.talent.name} ${props.publicView ? props.talent.lastName?.split(' ')[0] : props.talent.lastName}`}</span>
              <span className="talent-height text-capitalize">{measurements?.height ? `${measurements.height}cm / ${convertToFraction(measurements.height)}` : ''}</span>
          </div>
        }
      </div>
      {props.allowSelect &&
        <div className={'rc-talent-button-container text-center'}>
          <button onClick={() => statusSelection === 'like' ?  changeStatus('maybe') : changeStatus('like')} className={`${statusSelection} ${['like', 'maybe'].includes(statusSelection) ? 'selected' : ''}`}>
            <i className="fa-solid fa-check"></i>
          </button>
          <button onClick={() => changeStatus('unlike')} className={`unlike ${statusSelection === 'unlike' ? 'selected' : ''}`}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
      }
    </div>
    <style>{`
      .talent-out-popover { display: none; z-index: 10; white-space: nowrap; }
      .talent-out-indicator:hover .talent-out-popover { display: block; }
    `}</style>
  </div>
}
